import { NotificationTypeEnum } from "src/app/shared/enumerators/notification-type.enum"
import { MatIcon } from "@angular/material/icon"

const notificationImages = [
    {
        "id": 1,
        "type": NotificationTypeEnum.TaskCreated,
        "src": "../../../assets/icons/notification/taskCreated.svg",
    },
    {
        "id": 2,
        "type": NotificationTypeEnum.ContractorInTransit,
        "src": "../../../assets/icons/notification/contractorInTransit.svg",
    },
    {
        "id": 3,
        "type": NotificationTypeEnum.TaskScheduled,
        "src": "../../../assets/icons/notification/taskScheduled.svg",
    },
    {
        "id": 4,
        "type": NotificationTypeEnum.TaskAssigned,
        "src": "../../../assets/icons/notification/taskAssigned.svg",
    },
    {
        "id": 5,
        "type": NotificationTypeEnum.Rejected,
        "src": "../../../assets/icons/notification/rejected.svg",
    },
    {
        "id": 6,
        "type": NotificationTypeEnum.TaskFinished,
        "src": "../../../assets/icons/notification/taskFinished.svg",
    },
    {
        "id": 7,
        "type": NotificationTypeEnum.ContractorDelayed,
        "src": "../../../assets/icons/notification/contractorDelayed.svg",
    },
    {
        "id": 8,
        "type": NotificationTypeEnum.TaskUnAssigned,
        "src": "../../../assets/icons/notification/taskUnAssigned.svg",
    },
    {
        "id": 9,
        "type": NotificationTypeEnum.TaskReschedule,
        "src": "../../../assets/icons/notification/taskReschedule.svg",
    },
    {
        "id": 10,
        "type": NotificationTypeEnum.ContractorCreated,
        "src": "../../../assets/icons/notification/contractorCreated.svg",
    },
    {
        "id": 11,
        "type": NotificationTypeEnum.UserCreated,
        "src": "../../../assets/icons/notification/vendorCreated.svg",
    },
    {
        "id": 13,
        "type": NotificationTypeEnum.AOChangedItem,
        "src": "../../../assets/icons/notification/warning-triangle.svg",
    },
    {
        "id": 14,
        "type": NotificationTypeEnum.AOChangedQuantityItem,
        "src": "../../../assets/icons/notification/warning-triangle.svg",
    },
    {
        "id": 15,
        "type": NotificationTypeEnum.AOAddedItem,
        "src": "../../../assets/icons/notification/warning-triangle.svg",
    },
    {
        "id": 16,
        "type": NotificationTypeEnum.ManufacturingItemCreated,
        "src": "../../../assets/icons/notification/package.svg",
    },
    {
        "id": 17,
        "type": NotificationTypeEnum.UnpaidPaidLabor,
        "src": "../../../assets/icons/notification/warning-triangle.svg",
    }
]

export { notificationImages }